module.exports = __webpack_public_path__ + "img/GroupN14.82f59a43.png";